import Titulo from '../../../components/tipografia/Titulo';
import LayoutUsuario from '../../../components/navegacao/LayoutUsuario';
import Descricao from '../../../components/tipografia/Descricao';
import HBox from '../../../components/layout/HBox';
import VBox from '../../../components/layout/VBox';
import Grid, { GridItem } from '../../../components/layout/Grid';
import CampoSeletor from '../../../components/Formulario/CampoSeletor';
import CampoData from '../../../components/Formulario/CampoData';
import FiltroGrupoUsuario from '../../../components/Filtros/FiltroGrupoUsuario';
import { useState } from 'react';
import {
  PERIODO_RELATIVO_OPTIONS,
  resolvePeriodoRelativo,
  PeriodoRelativoToken,
} from '../util';
import TabelaPerformanceAtendentes from './TabelaPerformanceAtendentes';

const RelatorioAtendimentoHumanoPage = () => {
  const [periodoToken, setPeriodoToken] = useState<PeriodoRelativoToken>('hoje');
  const [customInicio, setCustomInicio] = useState<string>('');
  const [customFim, setCustomFim] = useState<string>('');
  const [grupoId, setGrupoId] = useState<number[]>([]);

  const { dataInicio, dataFim } = resolvePeriodoRelativo(
    periodoToken,
    customInicio,
    customFim,
  );

  return (
    <LayoutUsuario>
      <VBox gap="8px">
        <HBox>
          <VBox style={{ flex: 1 }}>
            <Titulo>Performance de atendimento humano</Titulo>
            <Descricao>
              Ranking de atendentes por qualidade de atendimento no período.
            </Descricao>
          </VBox>
        </HBox>

        <Grid>
          <GridItem sm={12} md={6} lg={4}>
            <HBox>
              <CampoSeletor
                noSearch
                options={PERIODO_RELATIVO_OPTIONS as unknown as { id: string; label: string }[]}
                placeholder="Filtrar por período"
                value={periodoToken}
                onChange={value => setPeriodoToken(value as PeriodoRelativoToken)}
                style={{ width: '100%', flex: 1 }}
              />
              {periodoToken === 'custom' && (
                <>
                  <CampoData
                    placeholder="Data inicial"
                    value={customInicio}
                    onChange={setCustomInicio}
                  />
                  <CampoData
                    placeholder="Data final"
                    value={customFim}
                    onChange={setCustomFim}
                  />
                </>
              )}
            </HBox>
          </GridItem>
          <GridItem sm={12} md={6} lg={4}>
            <FiltroGrupoUsuario
              value={grupoId.map(String)}
              onChange={(v) => setGrupoId(v.map(Number))}
            />
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12}>
            <TabelaPerformanceAtendentes dataInicio={dataInicio} dataFim={dataFim} grupoId={grupoId} />
          </GridItem>
        </Grid>
      </VBox>
    </LayoutUsuario>
  );
};

export default RelatorioAtendimentoHumanoPage;
